import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-ssangyong-help-section',
    templateUrl: './ssangyong-help-section.component.html',
    styleUrls: ['./ssangyong-help-section.component.less'],
    standalone: false
})
export class SsangyongHelpSectionComponent implements OnInit {

  @Input() subscribedData1: any;

  constructor() { }

  ngOnInit(): void {
  }

}
